import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createTextVNode("Create "),
  /*#__PURE__*/_createElementVNode("span", null, "Reference Request")
], -1)
const _hoisted_2 = {
  key: 0,
  class: "csearch"
}
const _hoisted_3 = { class: "formContent" }
const _hoisted_4 = { class: "overflowDiv" }
const _hoisted_5 = { class: "footersec" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Send Request")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["creteNewRRequest", _ctx.openedFrom === 'modal' ? 'modalWindow' : ''])
  }, [
    _hoisted_1,
    (_ctx.showLogezyCandidates)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_select, {
            value: _ctx.selectedCandidate,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCandidate) = $event)),
            placeholder: "Select Candidate",
            "show-search": "",
            "filter-option": _ctx.filterOption,
            onChange: _ctx.onSelecteCandidate,
            allowClear: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allCandidateLists, (candidate) => {
                return (_openBlock(), _createBlock(_component_a_select_option, {
                  value: candidate.value,
                  key: candidate.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(candidate.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["value", "filter-option", "onChange"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_form, {
        ref: "referenceRequestFormRef",
        model: _ctx.referenceRequestModal,
        rules: _ctx.referenceRequestRules,
        "label-col": _ctx.labelCol,
        "wrapper-col": _ctx.wrapperCol,
        colon: false
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_a_form_item, {
              label: "Candidate First Name",
              required: "",
              name: "first_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.referenceRequestModal.first_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.referenceRequestModal.first_name) = $event)),
                  type: "text",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Candidate Last Name",
              required: "",
              name: "last_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.referenceRequestModal.last_name,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.referenceRequestModal.last_name) = $event)),
                  type: "text",
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              ref: "email",
              required: "",
              label: "Candidate Email",
              name: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "",
                  value: _ctx.referenceRequestModal.email,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.referenceRequestModal.email) = $event)),
                  type: "text",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              ref: "phone",
              label: "Candidate Phone",
              name: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.referenceRequestModal.phone,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.referenceRequestModal.phone) = $event)),
                  placeholder: "",
                  "allow-clear": "",
                  autocomplete: "off"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 512),
            _createVNode(_component_a_form_item, {
              label: "Question Profile",
              required: "",
              name: "profile_id"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.referenceRequestModal.profile_id,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.referenceRequestModal.profile_id) = $event)),
                  placeholder: "",
                  "show-search": "",
                  "filter-option": _ctx.filterOption,
                  mode: "multiple"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allQprofiles, (profile) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: profile.id,
                        key: profile.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(profile.profile_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "filter-option"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Reference Required",
              required: "",
              name: "reference_required",
              class: "reqField"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.referenceRequestModal.reference_required,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.referenceRequestModal.reference_required) = $event)),
                  type: "number",
                  placeholder: ""
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Reason",
              name: "notes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: _ctx.referenceRequestModal.notes,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.referenceRequestModal.notes) = $event)),
                  placeholder: "Start Typing...",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              label: "Send Notification",
              name: "is_notify"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_switch, {
                  checked: _ctx.referenceRequestModal.is_notify,
                  "onUpdate:checked": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.referenceRequestModal.is_notify) = $event))
                }, null, 8, ["checked"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.openedFrom == 'modal')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  class: "cancle",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.cancelCandidaterequest()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.commonService.checkPermission('Candidate', 'create'))
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  class: "add",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sendRequest())),
                  loading: _ctx.confirmLoading
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["model", "rules", "label-col", "wrapper-col"])
    ])
  ], 2))
}